// BFF: ● policy_configurations — bffCrmPolicyConfiguration*.
export { default } from './BenefitPolicySettings'
